import HttpService from "@/service/HttpService";

export default class AbstractCrudService {
    constructor(path) {
        this.base_path = path;
    }

    paginated({ page, itemsPerPage, search, sortBy, sortDesc}) {
        return HttpService.backApi.get(
            this.base_path +
            "/paginated" +
            "?page=" +
            (page - 1) +
            "&size=" +
            itemsPerPage +
            "&search=" +
            search +
            this._sort(sortBy, sortDesc)
        );
    }

    create(body) {
        return HttpService.backApi.post(`${this.base_path}`, body);
    }

    delete(id) {
        return HttpService.backApi.delete(`${this.base_path}/${id}`);
    }

    byId(id) {
        return HttpService.backApi.get(
            this.base_path + "/" + id
        );
    }

    _sort(sortBy, sortDesc) {
        let sortUrl = "";
        if (!sortBy) {
            sortBy = "&sort=id,asc";
        }
        for (let i = 0; i < sortBy.length; i++)
            sortUrl += `&sort=${sortBy[i]},${(sortDesc[i] ? 'asc' : 'desc')}`
        return sortUrl;
    }
}